import React, { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import "../../assets/styles/local/ConfimationModal.css";

const ConfimationModal = (props) => {
  return (
    <>
      <Modal show={props.show} centered id="confirmation-popup">
        {props.title && props.title != "" && (
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">Title</Modal.Title>
          </Modal.Header>
        )}
        <Modal.Body className="confimation-modal-content p-5 mt-1">
          {props.description && props.description != "" && (
            <p>{props.description}</p>
          )}
          {props.subDescription && props.subDescription != "" && (
            <p className="mt-2">{props.subDescription}</p>
          )}

          <div className=" justify-centre modal-footer mt-4 pb-0">
            <button className="confimation-btn cancel" onClick={props.cancel}>
              {props.cancelLabel && props.cancelLabel != ""
                ? props.cancelLabel
                : "Cancel"}
            </button>
            {props.submitLable && props.submitLable != "" && (
              <button className="confimation-btn submit" onClick={props.submit}>
                {props.submitLable}
              </button>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ConfimationModal;
